<template>
    <div id="gallery_wrapper" :class="{single: settings.max == 1}">
        <ul v-if="loaded">
            <li v-for="pic in gallery" :key="pic.id">
                <div class="pic" :style="bg(pic.url)">
                    <a class="remove" @click="remove(pic)"><i class="far fa-trash-alt"></i></a>
                </div>
            </li>
            <li class="add" v-show="gallery.length < settings.max">
                <div class="pic" @click="chooseFiles()">
                    <input id="fileUpload" type="file" ref="fileinp" hidden @change="uploadFile">
                    <div class="progressbar"><div v-show="pic_loaded">טוען</div></div>
                    <i class="fas fa-plus"></i>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    props: ['modelValue','token','max'],
    emits: ['update:modelValue'],
    data() {
        return {
            value: this.modelValue,
            loaded: false,
            gallery: [],
            pic_loaded: false,
            settings: {
                max: 999
            }
        };
    },
    mounted(){
  
        if (this.value !== false && this.value.length > 0) this.gallery = (JSON.parse(JSON.stringify(this.value)));
        if (!this.isNull(this.max)) this.settings.max = this.max;
this.loaded = true;

/*
        this.api({ action: "add/get_steps", data: { token: this.token } }, (data) => {
            this.steps = data.data.steps;
            this.loaded = true;

            if (this.steps.length == 0) this.addStep();
        });
  */      
    },
    methods: {
        updateValue(){

            this.$emit('update:modelValue', this.gallery)
        },


        // GALLERY FUNCS
        remove(pic){
            if (confirm('האם למחוק את התמונה?'))
            {
                this.api({action: 'user_pictures/remove', data: {id: pic.id} }, (/*data*/) => {
                    for (let i in this.gallery)
                    {
                        if (this.gallery[i].id == pic.id)
                        {
                            this.gallery.splice(i, 1);
                            break;
                        }
                    }
                    
                    this.updateValue();
                });
            }
            
        },
        
        chooseFiles() {
            document.getElementById("fileUpload").click()
        },
        uploadFile(e){

            var self = this;
            let formData = new FormData();

            formData.append('token', this.token);
            formData.append('file', e.target.files[0]);

            var headers = { 'Content-Type': 'multipart/form-data', 'Accept': 'application/json' };
            
            if(!this.isNull(localStorage.getItem('user_token'))) 
            { 
                headers.Authorization = localStorage.getItem('user_token');
            }
            self.pic_loaded = true; 

            axios.post(window.api_url + 'user_pictures/upload', formData, {/*emulateJSON:true,*/ headers: headers})
            .then(response => {
                if (response.data == 'error')
                {
                    this.set_user_token('');
                    document.location.reload();
                }


                self.pic_loaded = false; 
                self.gallery.push(response.data.data);

                self.updateValue();
                
                // console.log(response.data);
            }, response => { 
                
                console.error(response.body);
            });

        },
    },
}

</script>
    
<style lang="scss" scoped>



#gallery_wrapper {
    .add { cursor: pointer;
        .pic { background:#eee; position: relative;
            .progressbar { position: absolute; left: 10px; right: 10px; bottom: 10px; }
            svg { position: absolute; top: 50%; margin:0 auto; text-align: center; font-size:40px; margin-top: -20px; pointer-events: none; left: 0; right: 0;}
        }
     }
    ul { display: grid; gap: 30px; grid-template-columns: repeat(3, 1fr);
        li { 
            .primary { display: block; margin:0 auto; width:15px; height: 15px; border-radius: 100%; box-shadow: 0px 0px 0px 3px #848797;  background:#848797;
                &.active { background:#25efd7;}
            }
        }
    }

    &.single ul { display: block;}

    .pic { width: 100%; padding-bottom: 140%; background:center center no-repeat; background-size: cover; overflow: hidden; display: block; border-radius: 15px; position: relative; margin-bottom: 8px;
        .remove { background:#bd1d1d; color:#fff; position: absolute; left: 10px; top: 10px; font-size: 14px; padding:5px; border-radius: 100%; width:30px; height: 30px; text-align: center;}
        &:not(:hover) .remove { display: none; }
        .moderation { position: absolute; bottom: 0px; right: 0px; left: 0px; text-align: center; font-size: 11px; background: rgba(0, 0, 0, 0.5); margin: 0 auto; color: #fff;}
    }

}

</style>